import React, { useState } from 'react';
import { FaTimes, FaEye, FaEyeSlash, FaThumbtack } from 'react-icons/fa';
import WebButton from '../webButton';

const ColumnSettings = ({ 
  columns, 
  visibleColumns,
  pinnedColumns = [],
  onToggleColumn,
  onTogglePin,
  onClose, 
  onResetColumns 
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredColumns = columns.filter(col => 
    col.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="column-settings-overlay">
      <div className="column-settings-panel">
        <div className="column-settings-header">
          <h3>Column Settings</h3>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <div className="column-settings-content">
          <div className="column-search">
            <input
              type="text"
              placeholder="Search columns..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="column-search-input"
            />
          </div>
          
          <div className="column-list">
            {filteredColumns.map(column => {
              const isVisible = visibleColumns.includes(column.key);
              const isPinned = pinnedColumns.includes(column.key);
              return (
                <div key={column.key} className="column-item">
                  <label className="column-label">
                    <input
                      type="checkbox"
                      checked={isVisible}
                      onChange={() => onToggleColumn(column.key)}
                    />
                    <span className="column-checkbox">
                      {isVisible ? <FaEye /> : <FaEyeSlash />}
                    </span>
                    <span className="column-name">{column.label}</span>
                  </label>
                  {isVisible && onTogglePin && (
                    <button 
                      className={`column-pin-btn ${isPinned ? 'pinned' : ''}`}
                      onClick={(e) => onTogglePin(e, column.key)}
                      title={isPinned ? 'Unpin column' : 'Pin column'}
                    >
                      <FaThumbtack />
                      <span>{isPinned ? 'Unpin' : 'Pin'}</span>
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        
        <div className="column-settings-footer">
          <WebButton
            text="Reset to Default"
            className="secondary-btn"
            onClick={onResetColumns}
          />
          <WebButton
            text="Apply"
            className="active_btn_with_shadow"
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default ColumnSettings;
